import useUserPermissions from '@UI/Providers/PermissionProvider/useUserPermissions';
import NAVIGATION_MENU, {
	type NavigationMenuDestination,
	type NavigationMenuEntryId,
} from '@UI/Routing/navigationMenu';
import * as React from 'react';

/** Destinations of a menu entry the user may reach; `[]` until permissions are resolved. */
const useAccessibleNavigationLevels = (
	entryId: NavigationMenuEntryId,
): readonly NavigationMenuDestination[] => {
	const { isResolved, hasAnyPermission } = useUserPermissions();

	return React.useMemo(() => {
		if (!isResolved) {
			return [];
		}

		const entry = NAVIGATION_MENU.flatMap((section) => section.entries).find(
			(candidate) => candidate.id === entryId,
		);

		if (entry === undefined) {
			return [];
		}

		return entry.destinations.filter((destination) => {
			return destination.permissions.length === 0 || hasAnyPermission(destination.permissions);
		});
	}, [entryId, isResolved, hasAnyPermission]);
};

export default useAccessibleNavigationLevels;
